export default "__VITE_ASSET__EBzNgqqg__"